export default "<main>\n  <h1>{{title}}</h1>\n  <app-cities></app-cities>  \n</main>"